/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { DiscountCardIcon } from './discount_card_icon'
import { calendarTheme } from './calendar_theme'

const previewVariantStyles = {
  default: {
    stackSpacing: 0.75,
    marginTop: 1,
    paddingX: 0.75,
    paddingY: 0.5,
    backgroundColor: calendarTheme.colors.previewBackground,
    iconSize: 24,
    iconRadius: '8px',
    iconBackgroundColor: calendarTheme.colors.previewIconBackground,
    discountCardIconSize: 16,
    cardsSpacing: 0.75,
    cardSize: 14,
    overflowCountFontSize: '11px',
  },
  compact: {
    stackSpacing: 0.5,
    marginTop: 0,
    paddingX: 0.5,
    paddingY: 0.35,
    backgroundColor: calendarTheme.colors.previewBackground,
    iconSize: 20,
    iconRadius: '8px',
    iconBackgroundColor: calendarTheme.colors.previewIconBackground,
    discountCardIconSize: 14,
    cardsSpacing: 0.5,
    cardSize: 10,
    overflowCountFontSize: '10px',
  },
  'inline-compact': {
    stackSpacing: 0.5,
    marginTop: 0,
    paddingX: 0.4,
    paddingY: 0.2,
    backgroundColor: calendarTheme.colors.previewBackground,
    iconSize: 16,
    iconRadius: '8px',
    iconBackgroundColor: calendarTheme.colors.previewBackground,
    discountCardIconSize: 11,
    cardsSpacing: 0.35,
    cardSize: 8,
    overflowCountFontSize: '9px',
  },
}

export const renderEventCardPreview = (cards, variant = 'default') => {
  if (!cards?.length) {
    return null
  }

  const previewVariant = previewVariantStyles[variant] || previewVariantStyles.default

  return (
    <Stack
      direction="row"
      spacing={previewVariant.stackSpacing}
      alignItems="center"
      sx={{
        mt: previewVariant.marginTop,
        px: previewVariant.paddingX,
        py: previewVariant.paddingY,
        borderRadius: '999px',
        width: 'fit-content',
        maxWidth: '100%',
        backgroundColor: previewVariant.backgroundColor,
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: previewVariant.iconSize,
          height: previewVariant.iconSize,
          borderRadius: previewVariant.iconRadius,
          backgroundColor: previewVariant.iconBackgroundColor,
        }}
      >
        <DiscountCardIcon size={previewVariant.discountCardIconSize} borderColor="#ffffff" strokeColor="#ffffff" />
      </Box>

      <Stack direction="row" spacing={previewVariant.cardsSpacing} alignItems="center">
        {cards.slice(0, 4).map((card) => (
          <Box
            key={card?.id}
            sx={{
              width: previewVariant.cardSize,
              height: previewVariant.cardSize,
              borderRadius: '50%',
              backgroundColor: card?.color,
              flexShrink: 0,
            }}
          />
        ))}
        {cards.length > 4 ? (
          <Typography sx={{ fontSize: previewVariant.overflowCountFontSize, fontWeight: 700, color: '#4b5563' }}>
            +{cards.length - 4}
          </Typography>
        ) : null}
      </Stack>
    </Stack>
  )
}
